import React from 'react';
import { AuthProvider, useAuth } from './auth/AuthContext';
import AdminLogin from './AdminLogin';
import GamesBannerAdmin from './GamesBannerAdmin';
import WidgetThemeStudio from './WidgetThemeStudio';
import './App.css';

const LEGACY_ADMIN_PATHS = ['/admin', '/games-admin'];

const AppShell = () => {
  const { firebaseUser, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="page">
        <div className="card">Loading…</div>
      </div>
    );
  }

  if (!firebaseUser) {
    return <AdminLogin />;
  }

  return (
    <div className="page">
      <header className="topbar">
        <div>
          <strong>Games Banner Admin</strong>
          <div className="subtle">Signed in as {firebaseUser.email || 'Unknown user'}</div>
        </div>
        <button type="button" className="secondary" onClick={logout}>Sign out</button>
      </header>
      <main>
        <GamesBannerAdmin />
      </main>
    </div>
  );
};

const normalizePath = (pathname) => {
  if (typeof pathname !== 'string') {
    return '/';
  }
  return pathname.replace(/\/+$/, '') || '/';
};

const readRuntimeEnv = (key) => {
  if (typeof window !== 'undefined' && window._env_ && typeof window._env_[key] !== 'undefined') {
    return window._env_[key];
  }
  return process.env[key];
};

const buildAdminPaths = () => {
  const configured = String(readRuntimeEnv('REACT_APP_ADMIN_PATH') || '').trim();
  if (!configured) {
    return LEGACY_ADMIN_PATHS;
  }
  return configured
    .split(',')
    .map((candidate) => candidate.trim())
    .filter(Boolean)
    .map((candidate) => (candidate.startsWith('/') ? candidate : `/${candidate}`))
    .map(normalizePath);
};

const isAdminPath = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const normalizedPath = normalizePath(window.location.pathname);
  return buildAdminPaths().includes(normalizedPath);
};

const App = () => {
  if (isAdminPath()) {
    return (
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    );
  }
  return <WidgetThemeStudio />;
};

export default App;
